import { Link } from 'react-router-dom'
import { WAAS_TIERS } from '../config/site'

const randFormatter = new Intl.NumberFormat('en-ZA', {
  style: 'currency',
  currency: 'ZAR',
  maximumFractionDigits: 0,
})

function Services() {
  return (
    <>
      <section className="hero hero--compact">
        <div className="container">
          <h1>Services</h1>
          <p className="tagline">
            From a fully-managed web presence to bespoke software and project consulting.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2>Website-as-a-Service</h2>
          <p className="lead">
            We build, host, and maintain your website for one predictable monthly fee — no large
            upfront cost. Pick the tier that fits; upgrade whenever you need to.
          </p>

          <div className="pricing">
            {WAAS_TIERS.map((tier) => (
              <div
                key={tier.name}
                className={`price-card${tier.featured ? ' price-card--featured' : ''}`}
              >
                {tier.featured && <span className="price-card__badge">Most popular</span>}
                <h3>{tier.name}</h3>
                <p className="price-card__price">
                  {randFormatter.format(tier.priceMonthly)}
                  <span className="price-card__per">/month</span>
                </p>
                <p className="price-card__tagline">{tier.tagline}</p>
                <ul className="price-card__features">
                  {tier.features.map((f) => (
                    <li key={f}>{f}</li>
                  ))}
                </ul>
                <Link className="btn btn--primary" to="/contact">
                  Enquire about {tier.name}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <h2>Custom builds &amp; consulting</h2>
          <div className="cards">
            <div className="card">
              <h3>Once-off custom website</h3>
              <p>
                A bespoke, owned-outright website or web app built to your exact requirements.
                Priced per project based on scope — get in touch for a quote.
              </p>
            </div>
            <div className="card">
              <h3>Custom software development</h3>
              <p>
                Tailored applications, integrations, and automation — cloud-native and AI-assisted.
                Quoted per engagement.
              </p>
            </div>
            <div className="card">
              <h3>Project consulting</h3>
              <p>
                Need a hand on an existing project or a second opinion on architecture, cloud, or AI
                adoption? We consult on a per-project basis.
              </p>
            </div>
          </div>
          <p className="cta-row">
            <Link className="btn btn--primary" to="/contact">
              Request a quote
            </Link>
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container container--narrow">
          <h2>Self-hosting &amp; site ownership</h2>
          <p className="lead">
            Prefer to own your site outright or host it on your own infrastructure? You&apos;re not
            locked in. We can hand over the full source and deployment setup, or help you move a
            Website-as-a-Service site onto your own cloud account whenever you&apos;re ready.
          </p>
          <ul className="feature-list">
            <li>Full source code and documentation handover</li>
            <li>Deployment to your own AWS (or other) account</li>
            <li>A clean exit from Website-as-a-Service — no lock-in</li>
            <li>Optional ongoing maintenance after transfer</li>
          </ul>
          <p className="cta-row">
            <Link className="btn btn--primary" to="/contact">
              Contact us about self-hosting or ownership
            </Link>
          </p>
        </div>
      </section>
    </>
  )
}

export default Services
